export default __webpack_public_path__ + "static/media/carousel-img-8.b31d5da9.webp";